import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import EcommerceProductActions from '../Redux/EcommerceProductRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getEcommerceProduct (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getEcommerceProduct, token, action.data)
      if (!res.ok) {
        yield put(EcommerceProductActions.getEcommerceProductFailure('GET_ECOMMERCE_PRODUCT_FAILURE'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(EcommerceProductActions.getEcommerceProductSuccess(DATA_WITH_PAGE))
        } else {
          yield put(EcommerceProductActions.getEcommerceProductFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(EcommerceProductActions.getEcommerceProductFailure())
  }
}

export function * viewEcommerceProduct (api, action) {
  yield baseFetchToken(
    api.viewEcommerceProduct,
    action.data,
    getToken,
    EcommerceProductActions.viewEcommerceProductSuccess,
    EcommerceProductActions.viewEcommerceProductFailure
  )
}

export function * createEcommerceProduct (api, action) {
  yield baseFetchToken(
    api.createEcommerceProduct,
    action.data,
    getToken,
    EcommerceProductActions.createEcommerceProductSuccess,
    EcommerceProductActions.createEcommerceProductFailure
  )
}

export function * createEcommerceProductStock (api, action) {
  yield baseFetchToken(
    api.createEcommerceProductStock,
    action.data,
    getToken,
    EcommerceProductActions.createEcommerceProductStockSuccess,
    EcommerceProductActions.createEcommerceProductStockFailure
  )
}

export function * updateEcommerceProduct (api, action) {
  yield baseFetchToken(
    api.updateEcommerceProduct,
    action.data,
    getToken,
    EcommerceProductActions.updateEcommerceProductSuccess,
    EcommerceProductActions.updateEcommerceProductFailure
  )
}

export function * deleteEcommerceProduct (api, action) {
  yield baseFetchToken(
    api.deleteEcommerceProduct,
    action.data,
    getToken,
    EcommerceProductActions.deleteEcommerceProductSuccess,
    EcommerceProductActions.deleteEcommerceProductFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/EcommerceProductSagas.js